import { cn } from "@ui/utils"

interface DataErrorProps {
  title?: string
  description?: string
  action?: React.ReactNode
  titleClassName?: string
  descriptionClassName?: string
}

export default function DataError({
  title = "Something went wrong",
  description = "There was an issue loading your data. Please try again",
  action,
  titleClassName,
  descriptionClassName,
}: DataErrorProps) {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 py-20">
      <div className="flex flex-col items-center gap-1">
        <p className={cn("text-md font-medium", titleClassName)}>{title}</p>
        {!!description && <p className={cn("text-muted-foreground text-sm", descriptionClassName)}>{description}</p>}
      </div>
      {action}
    </div>
  )
}
